import React, { useEffect, useState } from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import { LoginRequired } from '../../../hoc/LoginRequired.jsx';
import { Page } from '../../../hoc/Page.jsx';
import { getAuthor, getCollectionArrangements } from '../../../actions/collection';
import { addItemToBreadcrumbsArray, setBreadcrumbsArray, setPageHeadObject } from '../../../actions/app';
import ArrangementsList from '../Common/ArrangementsList.jsx';
import { getVisibleCollectionAuthors } from '../../../reducers/collection-selector';


const CollectionAuthorArrangements = ({ getAuthor,
                                        getCollectionArrangements,
                                        addItemToBreadcrumbsArray,
                                        setPageHeadObject}) => {
  let {slug} = useParams();

  useEffect(() => {
    getAuthor(slug).then(response => {
      if (response) {
        addItemToBreadcrumbsArray({title: response.full_name});
        setPageHeadObject({title: response.full_name});
        // setPageHeadObject({ title: DEPARTMENTS['collection']['children']['playlists']['title'] })
      }
    });
  }, []);

  const loadListFromServer = () => {return getCollectionArrangements(slug);}

  return <div>
    <ArrangementsList loadListFromServer={ loadListFromServer } redirectTo={ 'authors' } performerFilter={ true }/>
  </div>
}

CollectionAuthorArrangements.propTypes = {
  listCount: PropTypes.number.isRequired,
  getAuthor: PropTypes.func.isRequired,
  getCollectionArrangements: PropTypes.func.isRequired,

  addItemToBreadcrumbsArray: PropTypes.func.isRequired,
  setPageHeadObject: PropTypes.func.isRequired,
}

let mapStateToProps = (state) => {
  return {
    list: getVisibleCollectionAuthors(state),
    listCount: state.collection.listCount,
  }
};

export default compose(
  connect(mapStateToProps, { getAuthor, getCollectionArrangements, addItemToBreadcrumbsArray, setPageHeadObject }),
  LoginRequired,
  Page
)(CollectionAuthorArrangements);

